import styles from "./RecentBookingWidget.module.css";

const getCurrentMonthYear = () => {
  const date = new Date();
  return date.toLocaleString("en-US", { month: "short", year: "numeric" });
};

const getCurrentDate = (val=0) => {
  const date = new Date();
  return (date.getDate() + val).toString();
};

const getCurrentDayName = (val = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + val);
  return date.toLocaleString("en-US", { weekday: "short" });
};

const bookings = [
  {
    date: getCurrentDate(),
    day: getCurrentDayName(),
    title: "Gaming Booked",
    time: "9.00 AM",
    color: "#00CFFF",
  },
  {
    date: getCurrentDate(1),
    day: getCurrentDayName(1),
    title: "Tournament Booked",
    time: "1.30 PM",
    color: "rgb(219 148 39)",
  },
];

const RecentBookingWidget = () => {
  return (
    <div className={styles.widget}>
      <h4 className={styles.title}>{getCurrentMonthYear()}</h4>
      <div className={styles.list}>
        {bookings.map((slot, index) => (
          <div key={index} className={styles.slot}>
            <div className={styles.date}>
              <div className={styles.dateNumber}>{slot.date}</div>
              <div className={styles.day}>{slot.day.toLowerCase()}</div>
            </div>
            <div
              className={styles.event}
              style={{ backgroundColor: slot.color }}
            >
              <span className={styles.eventTitle}>{slot.title}</span>
              <span className={styles.eventTime}>{slot.time}</span>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.widgetLabel}>Recent Bookings</div>
    </div>
  );
};

export default RecentBookingWidget;
